import { Component, Inject, ViewChild } from '@angular/core';
import {MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA} from '@angular/material';
import {MatStepper} from '@angular/material';
import {TranslateService} from '@ngx-translate/core';
import { Ranking } from './ranking';
import { Comment } from './comment';
import { DbService } from './db.service';

export interface BottomSheetData {
  header: string;
  message: string
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  gaugeType = "semi";
  gaugeValue = 0;
  NameofPlayer = "anonymous";
  CommentofPlayer = "";
  rankings: Ranking[];
  comments: Comment[];
  error = '';
  success = '';
  Position = ['POSITION1', 'POSITION2', 'POSITION3', 'POSITION4'];
  SuccessCriteria = [4,4,4,4]; // ilosc projektow potrzebna do przejscia na wyzszy level, docelowo wszędzie po 5
  TotalProjects = 20;
  DialogStep = 0;
  Dialog = [
    {'step': -1, 'header': 'DIALOGH1',
    'message': 'DIALOGM1'},
    {'step': -1, 'header': 'DIALOGH2',
    'message': 'DIALOGM2'},
    {'step': -1, 'header': 'DIALOGH3',
    'message': 'DIALOGM3'},
    {'step': -1, 'header': 'DIALOGH4',
    'message': 'DIALOGM4'},
    {'step': 0, 'header': 'DIALOGH5',
    'message': 'DIALOGM5'},
    {'step': 0, 'header': 'DIALOGH6',
    'message': 'DIALOGM6'},
    {'step': 1, 'header': 'DIALOGH7',
    'message': 'DIALOGM7'},
    {'step': 1, 'header': 'DIALOGH8',
    'message': 'DIALOGM8'},
    {'step': 2, 'header': 'DIALOGH9',
    'message': 'DIALOGM9'},
    {'step': 3, 'header': 'DIALOGH10',
    'message': 'DIALOGM10'}
  ];
  ShowSpread = false;
  title = 'project risk simulation';
  Round = 0; // runda to jedna godzina
  GameOver = 0;
  countDown = 3;
  countedDown = false;
  SpeedValue = [100,180,250,350];
  Freeze = true;
  CurrentStep = -1; //aktualny krok w symulatorze, -1 oznacza ze jest to poczatkowy tutorial
  PercentDelivered = 0;
  TotalEffort = 0; // suma pracy rzeczywistej w zadaniach w projekcie
  TotalPlannedEffort = 0; // suma pracy estymowanej w danym momencie w projekcie
  TotalUpdatedEffort = 0; // wskaźnik używany do przeliczenia w trakcie realizacji projektu z TotalPlannedEffort na TotalEffort
  PlannedRemainingEffort = 0;
  TotalPlannedDuration = 0; // liczba estymowanych dni czasu trwania projektu
  PlannedMargin = 0.1;
  PlannedProfit = 0;
  DeliveredEffort = 0; // suma pracy już dostarczonej w zadaniach
  DurationOffer = 100; // roboczo zakomentowalem szacowanie czasu trwania i wpisałem przypadkowa wartosc tutaj, bo gra jest za trudna
  CostOffer = 0; // cena kontraktu podana przez gracza
  TenderFailFactor = 1.4; // próg po przekroczeniu którego przegrywa się przetarg
  TotalMissedProfit = 0; // suma przychodów nie osiągniętych na wszystkich kontraktach
  TotalProfitPercent = 0; //procent maksymalnego do osiągnięcia zysku uzyskanego przez gracza

  Team = [ // tabela z cechami pracowników, actualmean oznacza procent prognozy wzgledem rzeczywistej pracy w zadaniu, actualspread - procent*100*rzeczywisty czas w zadanu rozrzut prognoz {0,n}, np. 1 = prognozy od 0 do dwukrotnosci
    {'name': 'Marek', 'mean': 3, 'spread': 5, 'id': 0, 'guessmean': 1, 'guessspread': 1, 'actualmean': 1, 'actualspread': 2, 'plannedeffort': 0, 'guessedeffort': 0, 'spreadreduction': 0, 'meanreduction': 0},
    {'name': 'Anna', 'mean': 6, 'spread': 7, 'id': 1, 'guessmean': 0, 'guessspread': 1, 'actualmean': 0, 'actualspread': 2, 'plannedeffort': 0, 'guessedeffort': 0, 'spreadreduction': 0, 'meanreduction': 0},
    {'name': 'Robert', 'mean': 8, 'spread': 3, 'id': 2, 'guessmean': 3, 'guessspread': 1, 'actualmean': 3, 'actualspread': 1, 'plannedeffort': 0, 'guessedeffort': 0, 'spreadreduction': 0, 'meanreduction': 0},
    {'name': 'Nina', 'mean': 8, 'spread': 6, 'id': 3, 'guessmean': 3, 'guessspread': 0, 'actualmean': 4, 'actualspread': 1, 'plannedeffort': 0, 'guessedeffort': 0, 'spreadreduction': 0, 'meanreduction': 0},
    {'name': 'Marcel', 'mean': 4, 'spread': 8, 'id': 4, 'guessmean': 3, 'guessspread': 0, 'actualmean': 2, 'actualspread': 0, 'plannedeffort': 0, 'guessedeffort': 0, 'spreadreduction': 0, 'meanreduction': 0},
    {'name': 'Leon', 'mean': 9, 'spread': 3, 'id': 5, 'guessmean': 3, 'guessspread': 0, 'actualmean': 1, 'actualspread': 0, 'plannedeffort': 0, 'guessedeffort': 0, 'spreadreduction': 0, 'meanreduction': 0},
    {'name': 'Magda', 'mean': 9, 'spread': 3, 'id': 6, 'guessmean': 3, 'guessspread': 0, 'actualmean': 0, 'actualspread': 0, 'plannedeffort': 0, 'guessedeffort': 0, 'spreadreduction': 0, 'meanreduction': 0},
  ]
  TeamMeanDictionary = [ // value 1 oznacza brak przesunięcia prognozy, poniżej jeden oznacza wycenianie niżej niż naprawdę, powyżej jeden oznacza przeszacowywanie
    {'name': 'skrajny pesymista', 'value': 2},
    {'name': 'pesymista', 'value': 1.5},
    {'name': 'realista', 'value': 1},
    {'name': 'optymista', 'value': 0.5},
    {'name': 'skrajny optymista', 'value': 0.3}
  ]
  TeamSpreadDictionary = [ // value powinno rownac sie 0 dla braku zmiennosci. value oznacza rozrzut o wartości wielokrotności rzeczywistej pracochłonności zadania. value powinno być mniejsze od 1
    {'name': 'duży', 'value': 1.2},
    {'name': 'średni', 'value': 0.4},
    {'name': 'mały', 'value': 0.1}
  ]
  TeamStepConfiguration = [
    {'step': 0, 'member': 0},
    {'step': 1, 'member': 0},
    {'step': 1, 'member': 1},
    {'step': 1, 'member': 2},
    {'step': 2, 'member': 0},
    {'step': 2, 'member': 1},
    {'step': 2, 'member': 3},
    {'step': 2, 'member': 4},
    {'step': 2, 'member': 5},
    {'step': 3, 'member': 0},
    {'step': 3, 'member': 1},
    {'step': 3, 'member': 2},
    {'step': 3, 'member': 3},
    {'step': 3, 'member': 4},
    {'step': 3, 'member': 5},
    {'step': 3, 'member': 6}
  ];

  Tasks = [ // tabela z listą zadań, forecasteffort - rzeczywista praca wymagana w zadaniu, plannedeffort - szacowana prac w zadaniu przez człowieka
    {'name': 'Analiza 1', 'resource': 0, 'plannedeffort': 10, 'deliveredeffort': 0, 'forecasteffort': 10, 'startdate': '2019-01-01', 'enddate': '2019-01-02','dependency':'a'}
  ]

  Counteractions = [
    {'resource':0, 'spreadreduction': 0.5, 'meanreduction':0, 'cost': 20, 'purchased': false}
  ]

  TotalCounterationsCost = 0; // koszt kupionych przez gracza reakcji na ryzyka w danym projekcie
  TotalCounterationsCostinBasket = 0; // koszt wybrancyh do kupienia reakcji na ryzyka
  CounteractionsPurchased = false; // zmienna mówiąca, czy przy danym projekcie już kupiono reakcje na ryzyka

  ProjectResults = [
    {'profit': 0, 'duration': 0, 'margin': 0, 'costdeviation': 0, 'scheduledeviation': 0, 'missedprofit': 0}
  ]

  TaskResults = [
    {'step': 0, 'project': 0, 'member': 0, 'plan': 0, 'actual': 0}
  ];

  TornadoData = [
    {'member': 0, 'min': 10, 'max': 0, 'variation': -1, 'numberoftask': 0}
  ]
  
  SortedTornadoData = [
    {'member': 0, 'min': 10, 'max': 0, 'variation': -1, 'numberoftask': 0}
  ]

  ChartTornadoData = [ // dane do wykresu tornado, min i max są podwojone bo wykres rysowany jest na bazie wykresu świecowego z zerową długością świec
    ['anon',0,0,20,20]
  ];

  ChartTornadoColumns = ['imię','min', 'min', 'max', 'max'];

  ChartTornadoOptions = {
    hAxis: {title: 'Błędy estymacji zadań [%]',  titleTextStyle: {color: '#333'}},
    vAxis: {title: 'Ludzie', minValue: 0},
    orientation: 'vertical',
    legend:'none'
  };

  MonteCarloData = [
    [0,0]
  ]; // tabela zawiera wyliczone wartości funkcji transferu

  MonteCarloColumns = ['Case', 'Value'];
  
  MonteCarloOptions = {
    hAxis: {title: 'Prawdopodobieństwo kosztu projektu',  titleTextStyle: {color: '#333'}},
    vAxis: {title: 'Koszt projektu [$]', minValue: 0},
    orientation: 'horizontal',
    legend:'none'
  };

  ChartAccuracyData = [
    [0,20]
  ];

  ChartAccuracyColumns = ['ss','Trafność ofert'];

  ChartAccuracyOptions = {
    hAxis: {title: 'Projekt',  titleTextStyle: {color: '#333'}},
    vAxis: {title: '%', minValue: 0}
  };

  CurrentProject = 0; // numer aktualnie robionego projektu od początku levelu
  CurrentProjectTotal = 0 // numer aktualnie robionego projektu od początku gry
  CompanyProfit = 0; // zysk na projektach
  NumberOfTasks = [
    {'min': 3, 'max': 5},
    {'min': 7, 'max': 13}, 
    {'min': 13, 'max': 16},
    {'min': 20, 'max': 24},  
  ]; // liczba zadań losowanych w symulacji na roznych krokach symulacji
  MaxEffort = 10; // maksymalna praca w zadaniu
  MinEffort = 1; // minimalna praca w zadaniu

  ChartTitle = 'Release Burndown chart per Day (by Effort)';
  ChartType = 'Gantt';
  ChartColumns = ['Day'];
  ChartData = [
        ['Research', 'Find sources',
         new Date(2019, 1, 1), new Date(2011, 1, 5), null,  100,  null]
  ];
  ChartOptions = {
    gantt: {
      criticalPathEnabled: false,
      trackHeight: 30,
      barHeight: 15,
      percentEnabled: true,
      innerGridHorizLine: {
        stroke: '#ffe0b2',
        strokeWidth: 2
      },
      innerGridTrack: {fill: '#fff3e0'},
      innerGridDarkTrack: {fill: '#ffcc80'}
    }
  };
  chartwidth = 800;
  chartheight = 30*(9+1)+10;

  ranking = new Ranking('', 80);
  comment = new Comment('','');

  Alerts = [
    "PROJECTWASUPDATEDAFTERRISK",
    "TYPECONTRACTPRICE",
    "TYPEDURATIONBEFORESTART",
    "PROJECTEXECUTIONISSTARTED",
    "YOUGAVETOHIGHPRICE",
    "YOUFINISHEDPROJECT",
    "ONABOVETABLEYOUCANSEERESULTS"
  ]

  @ViewChild('stepper') stepper: MatStepper;

  constructor(/*private snackBar: MatSnackBar, */private DbService: DbService, private bottomSheet: MatBottomSheet, public translate: TranslateService) {
    translate.addLangs(['en', 'pl']);
    translate.setDefaultLang('en');

    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en|pl/) ? browserLang : 'en');

    let l = this.Dialog.length;
    for  (let i=0; i<l; i++) {
      translate.get(this.Dialog[i].header).subscribe((res: string) => {
        this.Dialog[i].header = res;
      });

      translate.get(this.Dialog[i].message).subscribe((res: string) => {
        this.Dialog[i].message = res;
      });
    }

    l = this.Position.length;
    for  (let i=0; i<l; i++) {
      translate.get(this.Position[i]).subscribe((res: string) => {
        this.Position[i] = res;
      });
    }

    l = this.Alerts.length;
    for  (let i=0; i<l; i++) {
      translate.get(this.Alerts[i]).subscribe((res: string) => {
        this.Alerts[i] = res;
      });
    }
  }

  ngOnInit(): void {
    this.launchBottomSheetIntro(); // seria okienek tutoriala
    this.getRanking();
    this.getComment();
    this.initiateTornado();
    this.CurrentStep++;
    this.generateTasks();
    this.generateCounteractions();
    this.createChartData();
    this.ProjectResults.splice(0);
    this.TaskResults.splice(0);
    this.ChartAccuracyData.splice(0);
    this.ChartTornadoData.splice(0);
    this.scheduleNextTurn(); // odpalenie pętli po raz pierwszy
  }

  launchBottomSheetIntro() {
    setTimeout(() => { 
      this.openBottomSheet(0,-1); //pokaz dialog tutoriala 
    }, 1000);
  }

  countDialogLength(level: number): number { // zlicza liczbę okienek w tutorialu na danym levelu
    let l = 0;
    let i: any;

    for (i in this.Dialog) {
      if (this.Dialog[i].step==level) l++;
    }
    return l;
  }

  openBottomSheet(step: number, level: number): void {
  
    if (step<(this.countDialogLength(level)+this.findFirstDialog(level))) {
      const bottomSheetRef = this.bottomSheet.open(IntroDialog, 
    {
    data: {
      header:  this.Dialog[step].header,
      message: this.Dialog[step].message,
    },
    disableClose: false,
    ariaLabel: 'Tutorial',
    panelClass: ['tutorial-bottom-sheet']
    });
    this.DialogStep++;

    bottomSheetRef.afterDismissed().subscribe(() => {
    this.openBottomSheet(this.DialogStep,level);
  });
  } else {
    this.DialogStep = -1;
  }
}

  doNextTurn() {
    if (this.GameOver<1) {
      this.scheduleNextTurn();
    
      //this.setCountDown();
      
        if (!this.Freeze) {
          this.Round++;
          this.updateTaskProgress();
          this.updateGanttData();
        } 
    if (this.PercentDelivered>=100) {
      this.GameOver=1;
      this.PlannedRemainingEffort = 0; // jezeli projekt okazal sie tanszy to trzeba wyzerowac prace pozostala
      this.summarizeProject(false);
    }
    }
  }

  scheduleNextTurn() {
      setTimeout(() => {
        this.doNextTurn();
      }, 200/this.SpeedValue[this.CurrentStep]);
  }

  setCountDown(): void {
    if (this.countedDown==false) { // odliczaj tylko gdy jeszcze nie zakonczono pierwszego odliczania
      let intervalId = setInterval(() => {
        this.countDown--;
        clearInterval(intervalId);
    }, 1000);
    }

    if (this.countDown<=0) {  // gdy zakonczono pierwsze odliczania
      this.countedDown = true;
    }

    if ((this.countDown==0)&&(this.countedDown==true)) {
      this.Freeze = false;
    }
  }

  generateTasks () {
    let numberoftasks = Math.floor(Math.random()*(this.NumberOfTasks[this.CurrentStep].max-this.NumberOfTasks[this.CurrentStep].min)+this.NumberOfTasks[this.CurrentStep].min); //losuje liczbe zadan w projekcie
    this.chartheight = 30*(numberoftasks+1)+10;
    this.Tasks.splice(0);
    let eff = 0;
    let r = 0;
    let forecast = 0;
    let taskname = '';
    let depend: string;
    let rescount = 100;
    let teamlength = 0;
    let k: any;
    let teammember = -1;
    let teammembers: number[] = new Array(0);

    for (k in this.TeamStepConfiguration) {
      if (this.TeamStepConfiguration[k].step==this.CurrentStep) {
        teamlength++;
        teammembers.push(this.TeamStepConfiguration[k].member);
      }
    }

    for (let i=0; i<numberoftasks; i++) {
      teammember = Math.floor(Math.random()*teamlength);
      teammember = teammembers[teammember];
      forecast = Math.floor(Math.random()*this.MaxEffort*this.Team[teammember].spread+this.MinEffort*this.Team[teammember].mean); // najpierw szacuje prawdziwą pracochłonność zadania na podstawie parametrów pracownika
      this.TotalEffort += forecast;
      if (forecast<=0) forecast = 1;
      eff = this.estimateTaskEffort(teammember, forecast); // a potem losuje szacunek pracownika na podstawie jego parametrów
      
      this.TotalPlannedEffort += eff;
      
      this.PlannedRemainingEffort = this.TotalEffort;
      this.PlannedProfit = this.CostOffer-this.TotalPlannedEffort;
      
      taskname = this.Team[teammember].name;
      taskname = taskname.concat('-',i.toString());
      let startdate: Date = new Date(this.countStartDate(teammember));
      let enddate: Date = new Date(startdate);
      enddate.setDate(startdate.getDate()+eff);
      depend = this.findDependency(teammember);
      this.Tasks.push({name: taskname, resource: teammember, plannedeffort: eff, deliveredeffort: 0, forecasteffort: forecast, startdate: startdate.toDateString(), enddate: enddate.toDateString(),dependency: depend})
    }
    this.TotalUpdatedEffort = this.TotalPlannedEffort;
    this.countProjectDuration();
    this.countTeamEffort();
  }

  estimateTaskEffort(teammember: number, forecast: number): number { // oblicza prognozę podaną przez pracownika na podstawie jego błędów i prawdziwego effortu
    let mean = this.TeamMeanDictionary[this.Team[teammember].actualmean].value;
    let meanreduction = this.Team[teammember].meanreduction;
    if (meanreduction>0) mean = 1+((mean-1)*meanreduction); // skoryguj parametr mean o zakupioną reakcję na ryzyka
    let spread = this.TeamSpreadDictionary[this.Team[teammember].actualspread].value;
    let spreadreduction = this.Team[teammember].spreadreduction;
    if (spreadreduction>0) spread = spread*spreadreduction;
    let randomspread = Math.random()*spread*forecast;
    let eff = Math.floor(forecast*mean+randomspread-randomspread/2);
    if (eff<=0) eff = 1;
    return eff;
  }

  generateCounteractions() {
    let i: any;
    this.Counteractions.splice(0);
    let teammembers: number[] = new Array(0);

    for (i in this.TeamStepConfiguration) {
      if (this.TeamStepConfiguration[i].step==this.CurrentStep) {
        teammembers.push(this.TeamStepConfiguration[i].member);
      }
    }

    for (i in teammembers) {
      this.Counteractions.push({resource: teammembers[i], spreadreduction: 0.5, meanreduction: 0, cost: 20, purchased: false});
      this.Counteractions.push({resource: teammembers[i], spreadreduction: 0, meanreduction: 0.5, cost: 20, purchased: false});
    }
  }

  countCounteractionsCost() {
    this.TotalCounterationsCostinBasket = 0;
    setTimeout(() => { //settimeout musi być, bo checkbox za pozno reaguje na zmiane zaznaczenia i generuje się bład przy sumowaniu
      for (let i=0; i<this.Counteractions.length; i++) {
        if (this.Counteractions[i].purchased) this.TotalCounterationsCostinBasket += this.Counteractions[i].cost;
      }
    }, 10);
  }

  buyCounteractions() { // trzeba na nowo przeliczyć estymacje po zakupieniu przeciwdziałań ale to chyba powinno się odbyć po kliknięciu guzika "kup przeciwdziałania"
    if (this.TotalCounterationsCostinBasket>0) {
      this.TotalCounterationsCost = this.TotalCounterationsCostinBasket;
      this.CounteractionsPurchased = true;

      for (let i=0; i<this.Team.length; i++) {
        this.Team[i].spreadreduction=0;
        this.Team[i].meanreduction=0;
      }

      for (let i=0; i<this.Counteractions.length; i++) {
        if (this.Counteractions[i].purchased) {
          this.Team[this.Counteractions[i].resource].meanreduction = this.Counteractions[i].meanreduction;
          this.Team[this.Counteractions[i].resource].spreadreduction = this.Counteractions[i].spreadreduction;
        }     
      }

      let forecast: number;
      let teammember: number;
      let eff: number;
      this.TotalPlannedEffort = 0;
      let depend: string;

      for (let i=0; i<this.Tasks.length; i++) {  // przelicza szacunki dla wszystkich zadań
        forecast = this.Tasks[i].forecasteffort;
        teammember = this.Tasks[i].resource;
        eff = this.estimateTaskEffort(teammember,forecast);
        this.Tasks[i].plannedeffort = eff;

        this.TotalPlannedEffort += eff;
      
        this.PlannedRemainingEffort = this.TotalEffort;
        this.PlannedProfit = this.CostOffer-this.TotalPlannedEffort;

        let startdate: Date = new Date(this.countStartDate(teammember));
        let enddate: Date = new Date(startdate);
        enddate.setDate(startdate.getDate()+eff);
        depend = this.findDependency(teammember);
        this.Tasks[i].startdate = startdate.toDateString();
        this.Tasks[i].enddate = enddate.toDateString();
      }
      this.TotalUpdatedEffort = this.TotalPlannedEffort;
      this.countProjectDuration();
      this.countTeamEffort();
      if (this.stepper.selectedIndex>1) { // tylko od kroku 3 licz tornado i monte carlo
        this.countTornado();
        this.updateTornadoChart();
        this.countMonteCarlo();
      }

      alert(this.Alerts[0]);
    }
  }

  countTeamEffort() {
    let i: any;
    for (i in this.Team) {
      this.Team[i].plannedeffort = 0;
    }
    this.TotalPlannedEffort = 0;
    for (i in this.Tasks) {
      this.Team[this.Tasks[i].resource].plannedeffort += this.Tasks[i].plannedeffort; 
      this.TotalPlannedEffort += this.Tasks[i].plannedeffort;
    }
    this.TotalUpdatedEffort = this.TotalPlannedEffort;
  }

  recountEffortBasedOnActual() { // funkcja odpalana tuż przed uruchomieniemn projektu, która przelicza estymacje zadań po faktycznych profilach pracowników
    let i: any;
    let eff: number;
    let res = 0;
    let forecast = 0;
    this.TotalPlannedEffort = 0;

    for (i in this.Tasks) {
      res = this.Tasks[i].resource;
     
      forecast = this.Tasks[i].forecasteffort;
      eff = this.Tasks[i].plannedeffort;
      this.TotalPlannedEffort += eff;
      this.Tasks[i].plannedeffort = eff;
      let startdate: Date = new Date(this.countStartDateForTask(res,i));
      let enddate: Date = new Date(startdate);
      enddate.setDate(startdate.getDate()+eff);

      this.Tasks[i].startdate = startdate.toDateString();
      this.Tasks[i].enddate = enddate.toDateString();
    }
    this.countProjectDuration();
    this.PlannedRemainingEffort = this.TotalEffort;
    
    this.PlannedProfit = this.CostOffer-this.TotalPlannedEffort;
    //this.countTeamEffort();
  }

  getDiffDate(later: Date, earlier: Date): number {
    let oneday = 1000 * 60 * 60 * 24;
    let date1_ms = later.getTime();
    let date2_ms = earlier.getTime();
    let difference_ms = Math.abs(date1_ms - date2_ms);

    let days = Math.round(difference_ms/oneday);
    return days;
  }

  findDependency(res: number): string {
    let names: string;
    let i: any;

    for (i in this.Tasks) {
      if (this.Tasks[i].resource==res) {
        names = this.Tasks[i].name;
      }
    }
    return names;
  }

  countStartDate(res: number): Date {
    let i: any;
    let startdate = new Date();

    if (this.Tasks) {
      for (i in this.Tasks) {
        if (this.Tasks[i].resource==res) {
         startdate.setDate(startdate.getDate()+this.Tasks[i].plannedeffort);
        }
    }
    }
    return startdate;
  }

  countStartDateForTask(res: number,nr: number): Date {
    let i: any;
    let startdate = new Date();

    if (this.Tasks) {
      for (let i=0; i<nr; i++) {
        if (this.Tasks[i].resource==res) {
         startdate.setDate(startdate.getDate()+this.Tasks[i].plannedeffort);
        }
    }
    }
    return startdate;
  }

  setTasksDates(res: number) {
    let i: any;
    let startdate = new Date();
    if (this.Tasks) {
      for (i in this.Tasks) {
        if (this.Tasks[i].resource==res) {
          this.Tasks[i].startdate = startdate.toDateString();
          let enddate: Date = new Date(startdate);  
          enddate.setDate(startdate.getDate()+this.Tasks[i].plannedeffort);

          this.Tasks[i].enddate = enddate.toDateString();
          startdate = enddate; 
        }
    }
    }
  }

  daysToMilliseconds(days: number): number {
    return days * 24 * 60 * 60 * 1000;
  }

  createChartData() {
    let i: any;

    this.ChartData.splice(0);
    for (i in this.Tasks) {
      this.ChartData.push([this.Tasks[i].name, this.Tasks[i].name, this.Team[this.Tasks[i].resource].name, new Date(this.Tasks[i].startdate), new Date(this.Tasks[i].enddate), 0,  100,  this.Tasks[i].dependency]);
    }

    this.refreshGantt();
  }

  updateGanttData() {
    let i: any;
    let percent = 0;

    for (i in this.ChartData) {
      percent = 100*(this.Tasks[i].deliveredeffort / this.Tasks[i].forecasteffort);

      this.ChartData[i][6] = percent;
      this.ChartData[i][3] = new Date(this.Tasks[i].startdate);
      this.ChartData[i][4] = new Date(this.Tasks[i].enddate);
    }
    this.refreshGantt();
  }

  updateTaskProgress() {
    let i: any;
    let deviation: number;
    let deviationreduction: number;
    let deliveredpercent: number;
    

    if (this.Tasks) {
     this.countProjectDuration();
      for (i in this.Tasks) {
        if ((this.Tasks[i].deliveredeffort<this.Tasks[i].forecasteffort)&&(this.ifPrecedessorsDone(i))) {
          this.Tasks[i].deliveredeffort += 1/8;
          this.DeliveredEffort += 1/8;
          this.PlannedRemainingEffort -= 1/8;

          if (this.PlannedRemainingEffort<0) this.PlannedRemainingEffort = 0;
          this.PercentDelivered = 100*this.DeliveredEffort / this.TotalEffort;
          this.TotalUpdatedEffort = this.TotalEffort*(this.DeliveredEffort/this.TotalEffort)+this.TotalPlannedEffort*(this.PlannedRemainingEffort/this.TotalEffort);

          deviation = this.Tasks[i].plannedeffort-this.Tasks[i].forecasteffort;
          deliveredpercent = this.Tasks[i].deliveredeffort / this.Tasks[i].forecasteffort;
          deviationreduction = Math.floor(deviation * deliveredpercent);

          let enddate: Date = new Date(this.Tasks[i].startdate);
          enddate.setDate(new Date(this.Tasks[i].startdate).getDate()+this.Tasks[i].plannedeffort-deviationreduction);
          this.Tasks[i].enddate = enddate.toDateString();

          this.moveNextTask(i);
        }
      }
    }
    this.PlannedProfit = this.CostOffer-this.TotalUpdatedEffort;
  }

  countProjectDuration() {
    this.TotalPlannedDuration = 0;
    let i: any;
    let now: Date = new Date();
    for (i in this.Tasks) {
      let diffdate = this.getDiffDate(new Date(this.Tasks[i].enddate),now);
      if (diffdate>this.TotalPlannedDuration) this.TotalPlannedDuration = diffdate;
    }
  }

  moveNextTask(tas: number) {
    let i: any;
    let enddate: Date;
    for (i in this.Tasks) {
      if (tas===this.getIdTaskByName(this.Tasks[i].dependency)) {
        this.Tasks[i].startdate = this.Tasks[tas].enddate;
        enddate = new Date(this.Tasks[i].startdate);
        enddate.setDate(enddate.getDate()+this.Tasks[i].plannedeffort);
        this.Tasks[i].enddate = enddate.toDateString();

        this.moveNextTask(i);
      }
    }
  }

  getIdTaskByName(dep: string): number {
    let i: any;
    let id = -1;

    for (i in this.Tasks) {
      if (this.Tasks[i].name==dep)
        id = i;
    }
    return id;
  }

  ifPrecedessorsDone (tas: number): boolean {
    let done = true;
    let i: any;
    let d = -1;
    for (i in this.Tasks) {
      if (this.Tasks[i].name==this.Tasks[tas].dependency)
        d = i;
    }
 
    if (d>-1)
      if (this.Tasks[d].forecasteffort>this.Tasks[d].deliveredeffort)
        done = false;

    return done;
  }

  getTaskIdByMaxEndDate(): number {
    let i: any;
    let endtask = 0;
    let enddate: Date = new Date();
    for (i in this.Tasks) {
      if (new Date(this.Tasks[i].enddate)>enddate) {
        endtask = i;
        enddate.setDate(new Date(this.Tasks[i].startdate).getDate());
      }
    }
    return endtask;
  }

  ResetTeamSettings() {
    let i: any;
    for (i in this.Team) {
      this.Team[i].guessmean = 2;
      this.Team[i].guessspread = 1;
    }
    this.countTasksOnGuess();
  }

  countTasksOnGuess() {
    let i: any;
    let eff: number;
    let res: number;
    let forecast: number;

    this.TotalPlannedEffort = 0;
    
    for (i in this.Tasks) {
      res = this.Tasks[i].resource;
      forecast = this.Tasks[i].forecasteffort; // najpierw bierze prawdziwą pracochłonność zadania
      eff = Math.floor(forecast*Math.random()*this.TeamSpreadDictionary[this.Team[res].guessspread].value+(forecast*this.TeamMeanDictionary[this.Team[res].guessmean].value)); // a potem losuje szacunek pracownika na podstawie jego parametrów
      if (eff<=0) eff = 1;
      this.TotalPlannedEffort += eff;
      this.PlannedRemainingEffort = this.TotalEffort;

      this.Tasks[i].plannedeffort = eff;
    }
    this.PlannedProfit = this.CostOffer-this.TotalPlannedEffort;
    for (i in this.Team) {
      this.setTasksDates(i);
    }

    this.createChartData();
    this.refreshGantt();
    this.countProjectDuration();
    this.countTeamEffort();
  }

  refreshGantt() {
    this.ChartData = this.ChartData.slice();
  }

  setOffer() {
    this.DurationOffer = this.TotalPlannedDuration;
    this.CostOffer = Math.floor(this.TotalUpdatedEffort*(this.PlannedMargin+1));
    this.PlannedProfit = this.CostOffer-this.TotalUpdatedEffort;
  }

  setNewCostOffer() {
    this.PlannedProfit = this.CostOffer-this.TotalPlannedEffort;
  }

  checkPrice() {
    if (this.CostOffer<=0) {
      alert(this.Alerts[1]);
      this.Freeze = true;
    }

    if (this.DurationOffer<=0) {
      alert(this.Alerts[2]);
      this.Freeze = true;
    }

    if ((this.CostOffer>0)&&(this.DurationOffer>0)) {
      let tenderfail = this.checkTenderFail();
      if (!tenderfail) {
        this.recountEffortBasedOnActual();
        this.Freeze = false;
        alert(this.Alerts[3]);
      } else {
        let cost= this.TotalEffort/2; // w razie przegrania przetargu płaci się połowę kosztu ludzi w tym projekcie
        alert(this.Alerts[4]+cost+ " $");
        this.PlannedProfit = -cost;
        this.PercentDelivered = 100;
        this.GameOver=1;
        this.PlannedRemainingEffort = 0; // jezeli projekt okazal sie tanszy to trzeba wyzerowac prace pozostala

        this.summarizeProject(tenderfail);
      }
    }
  }

  summarizeProject(tenderfail: boolean) {
    this.copyTaskResults(); // przekopiuj wyniki zadań do osobnej tabeli
    if (this.stepper.selectedIndex>1) { // tylko od kroku 3 licz tornado i monte carlo
      this.countTornado();
      this.updateTornadoChart();
      this.countMonteCarlo();
    }
    this.CurrentProject++;
    this.CurrentProjectTotal++;
    let costdeviation = 100*(this.TotalPlannedEffort-this.TotalEffort-this.TotalCounterationsCost)/this.TotalEffort;
    let scheduledeviation = 100*(this.DurationOffer-this.TotalPlannedDuration)/this.TotalPlannedDuration;
    let missedprofit: number;
    this.PlannedProfit = this.CostOffer - this.TotalEffort - this.TotalCounterationsCost;
    if (!tenderfail) {
      this.CompanyProfit += this.PlannedProfit;
      missedprofit = this.TotalEffort*this.TenderFailFactor-this.CostOffer;
      alert(this.Alerts[5]);
      this.ProjectResults.push({'profit': this.PlannedProfit, 'duration': this.TotalPlannedDuration, 'margin': 100*((this.CostOffer-this.TotalEffort-this.TotalCounterationsCost)/(this.TotalEffort+this.TotalCounterationsCost)), 'costdeviation': costdeviation, 'scheduledeviation': scheduledeviation, 'missedprofit': missedprofit});
      this.gaugeValue = Math.floor(100*(this.CostOffer / (this.TotalEffort*this.TenderFailFactor)));
      } else {
      this.CompanyProfit -= this.TotalEffort/2+this.TotalCounterationsCost;
      missedprofit = this.TotalEffort*this.TenderFailFactor;
      alert(this.Alerts[6]);
      this.ProjectResults.push({'profit': -this.TotalEffort/2, 'duration': 0, 'margin': 0, 'costdeviation': 0, 'scheduledeviation': 0, 'missedprofit': missedprofit});
      this.gaugeValue = Math.floor(100*((this.TotalEffort*this.TenderFailFactor) / this.CostOffer));
      }
    this.TotalMissedProfit +=missedprofit;
    this.ChartAccuracyData.push([this.CurrentProjectTotal,this.gaugeValue]);
    this.ChartAccuracyData = this.ChartAccuracyData.slice();

    if (this.CompanyProfit>0) 
      this.TotalProfitPercent = this.CompanyProfit/(this.TotalMissedProfit+this.CompanyProfit)*100;
      else
      this.TotalProfitPercent = 0;
    }

  updateTornadoChart() {
    this.ChartTornadoData.splice(0);
    this.SortedTornadoData.splice(0);
    let i: any;

    for (i in this.TornadoData) 
      this.SortedTornadoData.push({'member': this.TornadoData[i].member, 'min': this.TornadoData[i].min, 'max': this.TornadoData[i].max, 'variation': this.TornadoData[i].variation, 'numberoftask': this.TornadoData[i].numberoftask});

    this.SortedTornadoData.sort(function(a, b){return (b.variation)-(a.variation)});
    for (i in this.SortedTornadoData) {
      //console.log(" max "+this.SortedTornadoData[i].max+" min "+this.SortedTornadoData[i].min)
      if (this.SortedTornadoData[i].variation>=0) {
        this.SortedTornadoData[i].min -= 1; 
        this.SortedTornadoData[i].max -= 1;
        this.ChartTornadoData.push([this.Team[this.SortedTornadoData[i].member].name, this.SortedTornadoData[i].min, this.SortedTornadoData[i].min, this.SortedTornadoData[i].max, this.SortedTornadoData[i].max]);
      }
    }
    this.ChartTornadoData = this.ChartTornadoData.slice();
    }

  launchProject() {
    this.CounteractionsPurchased = false;
    this.TotalCounterationsCost = 0;
    this.TotalCounterationsCostinBasket = 0;
    this.Round = 0; // runda to jedna godzina
    this.GameOver = 0;
    this.countDown = 3;
    this.countedDown = false;
    this.Freeze = true;
    this.PercentDelivered = 0;
    this.TotalEffort = 0; // suma pracy rzeczywistej w zadaniach w projekcie
    this.TotalPlannedEffort = 0; // suma pracy estymowanej w danym momencie w projekcie
    this.TotalUpdatedEffort = 0;
    this.PlannedRemainingEffort = 0;
    this.TotalPlannedDuration = 0; // liczba estymowanych dni czasu trwania projektu
    this.PlannedProfit = 0;
    this.DeliveredEffort = 0; // suma pracy już dostarczonej w zadaniach
    this.DurationOffer = 100;
    this.CostOffer = 0;
  
      if (this.CurrentProject>=this.SuccessCriteria[this.CurrentStep]) { // jezeli wykonano limit projektow na levelu to podsumuj level
  
        this.SummarizeLevel();
        this.stepper.selected.completed = true;
        this.stepper.next(); // przewiń o krok po wyświetleniu podsumowania
        this.launchLevel();
      } else { // w przeciwnym wypadku wygeneruj kolejny projekt
        this.generateTasks();
        this.generateCounteractions();
        this.createChartData();
        if (this.stepper.selectedIndex>1) { // tylko od kroku 3 licz tornado i monte carlo
          this.countTornado();
          this.updateTornadoChart();
          this.countMonteCarlo();
        }
        this.scheduleNextTurn();
      }
  
    }

  launchLevel() {
    if (this.stepper.selectedIndex <= 3) {
      this.CurrentProject = 0;
      this.CurrentStep++;
      this.generateTasks();
      this.generateCounteractions();
      this.createChartData();
      if (this.stepper.selectedIndex>1) { // tylko od kroku 3 licz tornado i monte carlo
        this.countTornado();
        this.updateTornadoChart();
        this.countMonteCarlo();
      }
      this.scheduleNextTurn();
    } else {
      this.stepper.next(); // przewiń o krok po wyświetleniu podsumowania
      this.addRanking();
    }
  }

  SummarizeLevel() {
    this.DialogStep = this.findFirstDialog(this.CurrentStep);
    this.openBottomSheet(this.DialogStep,this.CurrentStep);
  }

  findFirstDialog(step: number): number {
    let i = 0;
    let nr = -1;
    while (nr<0) {
      if (this.Dialog[i].step==step) {
        nr = i;
      }
      i++;
    }
    return nr;
  }

  checkTenderFail(): boolean {
    let tenderfail = false;
    if (this.CostOffer/this.TotalEffort>this.TenderFailFactor) {
      tenderfail = true;
    }
    return tenderfail;
  }

  copyTaskResults() {
    let i: any;

    for (i in this.Tasks) {
      this.TaskResults.push({'step': this.CurrentStep, 'project': this.CurrentProject, 'member': this.Tasks[i].resource, 'plan': this.Tasks[i].plannedeffort, 'actual': this.Tasks[i].forecasteffort})
    }
  }

  initiateTornado() {
    let i: any;
    this.TornadoData.splice(0);

    for (i in this.Team) {
      this.TornadoData.push({member: this.Team[i].id, min: 10, max: 0, variation: -1, numberoftask: 0}); // min=10 to po prostu wystarczajaco duzy parametr aby pozniej dalo sie wyznaczac od niego minimum
    }
  }


  countTornado() { // funkcja liczy rozrzut błędów wycen dla każdego człowieka, potrzebna do wykresu tornado
    let deviation: number;
    let member: number;

    for (let i=0; i<this.TaskResults.length; i++) {
        member = this.TaskResults[i].member;
        deviation = this.TaskResults[i].plan/this.TaskResults[i].actual;
        //console.log("taskresults member"+this.TaskResults[i].member+" deviation "+deviation);
        if (this.TornadoData[member].min>deviation)
          this.TornadoData[member].min = deviation;
  
        if (this.TornadoData[member].max<deviation)
          this.TornadoData[member].max = deviation;
  
        this.TornadoData[member].variation = this.TornadoData[member].max - this.TornadoData[member].min;
        this.TornadoData[member].numberoftask++;
    //    console.log("min "+this.TornadoData[member].min+" max "+this.TornadoData[member].max)
    }
  }

  getRanking(): void {
    this.DbService.getAll().subscribe(
      (res: Ranking[]) => {
        this.rankings = res;
      },
      (err) => {
        this.error = err;
      }
    );
  }

  getComment(): void {
    this.DbService.getComments().subscribe(
      (res: Comment[]) => {
        this.comments = res;
      },
      (err) => {
        this.error = err;
      }
    );
  }

  addRanking() {
    this.error = '';
    this.success = '';
    this.ranking = new Ranking ('',10);
    this.ranking.name = this.NameofPlayer;
    this.ranking.deliveredvalue = this.CompanyProfit;

    this.DbService.store(this.ranking)
      .subscribe(
        (res: Ranking[]) => {
          
          // Update the ranking
          this.rankings = res;
          
          // Inform the user
          this.success = 'Created successfully';
        },
        (err) => this.error = err
      );

      this.getRanking();
  }

  addComment() {
    this.error = '';
    this.success = '';
    this.comment = new Comment ('','');
    this.comment.nickname = this.NameofPlayer;
    this.comment.comment = this.CommentofPlayer;

    this.DbService.store_comment(this.comment)
      .subscribe(
        (res: Comment[]) => {
          
          // Update list of comments
          this.comments = res;
          
          // Inform the user
          this.success = 'Created successfully';
        },
        (err) => this.error = err
      );

      this.getComment();
  }

  countMonteCarlo () {
    let i: any;
    let transfervalue: number;
    let forecast: number;
    let teammember: number;
    let iterations = 1000; // ile razy powtórzyć losowanie dla monte carlo
    this.MonteCarloData.splice(0);
    
    for (let j=0; j<iterations; j++) {
      transfervalue = 0;1
      for (i in this.Tasks) {
        forecast = this.Tasks[i].plannedeffort;
        teammember = this.Tasks[i].resource;
        transfervalue += this.estimateTaskEffortbyTornado(teammember, forecast); // losuje szacunek pracownika na podstawie jego parametrów
      }
      this.MonteCarloData.push([j,transfervalue]);
    }
    this.MonteCarloData.sort(function(a, b) {return a[1]-b[1];}); // wartości na wykresie musza być posortowane

    for (i in this.MonteCarloData) {
      this.MonteCarloData[i][0] = i/iterations;
    }
    this.MonteCarloData = this.MonteCarloData.slice();
  }

  estimateTaskEffortbyTornado(teammember: number, forecast: number): number { // oblicza prognozę podaną przez pracownika na podstawie rozrzutu błędów zarejestrowanych w Tornado i prawdziwego effortu
    let min: number;
    let max: number;
    if (this.TornadoData[teammember].min==10)
      max = forecast;
      else
      max = forecast/(this.TornadoData[teammember].min); // maksymalna wartość prognozy

    if (this.TornadoData[teammember].max==0)
      min = forecast;
      else
      min = forecast/(this.TornadoData[teammember].max); // minimalna wartość prognozy
  
    //if (min==0) min = forecast;
    //if (max==0) max = forecast;

    let eff = min+(Math.random()*(max-min));
    if (eff<=0) eff = 1;
 //   if (teammember==3)
    //  console.log(" member "+teammember+" forecast"+forecast+" max"+ max+ " min "+ min+" eff "+eff);
    return eff;
  }
}

@Component({
  selector: 'IntroDialog',
  templateUrl: 'bottom-sheet-tutorial.html',
})
export class IntroDialog {
  constructor(
    private bottomSheetRef: MatBottomSheetRef<IntroDialog>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: BottomSheetData) {}

  openLink(event: MouseEvent): void {
    this.bottomSheetRef.dismiss();
    event.preventDefault();
  }

  closeTutorial() {
    this.bottomSheetRef.dismiss();
    event.preventDefault();
    
  }
}